"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _encryption = _interopRequireDefault(require("../encryption"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Pocket = exports["default"] = /*#__PURE__*/function (_Core) {
  function Pocket(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Pocket);
    _this = _callSuper(this, Pocket, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.init();
    _this.cryptoKey = props.cryptoKey;
    _this.publicKey = props.publicKey;
    _this.services = props.services;
    _this.ready = false;
    // Only focusing on `pocket` (MoneyManager)
    _this.myServices = ["pocket"];
    return _this;
  }
  (0, _inherits2["default"])(Pocket, _Core);
  return (0, _createClass2["default"])(Pocket, [{
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "fetchTransactions",
    value: function () {
      var _fetchTransactions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var command, uuid, origin, timestamp, payload, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              command = "System.MoneyManager.FetchTransactions";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["pocket"], {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              payload = _context.sent;
              _context.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context.next = 3;
              return this.waitForResponse(command, uuid, this.services["pocket"]);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
              _context.prev = 4;
              _t = _context["catch"](0);
              console.error("Error in fetchTransactions:", _t);
              throw _t;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 4]]);
      }));
      function fetchTransactions() {
        return _fetchTransactions.apply(this, arguments);
      }
      return fetchTransactions;
    }()
  }, {
    key: "fetchTransApoens",
    value: function () {
      var _fetchTransApoens = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var command, uuid, origin, timestamp, payload, _t2;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              command = "System.MoneyManager.FetchTransApoens";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context2.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["pocket"], {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              payload = _context2.sent;
              _context2.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context2.next = 3;
              return this.waitForResponse(command, uuid, this.services["pocket"]);
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](0);
              console.error("Error in fetchTransApoens:", _t2);
              throw _t2;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 4]]);
      }));
      function fetchTransApoens() {
        return _fetchTransApoens.apply(this, arguments);
      }
      return fetchTransApoens;
    }()
  }, {
    key: "payinCancel",
    value: function () {
      var _payinCancel = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(id) {
        var command, uuid, origin, timestamp, payload, _t3;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              command = "System.MoneyManager.PayinCancel";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context3.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["pocket"], {
                command: command,
                params: {
                  id: id
                }
              }, uuid, origin, timestamp);
            case 1:
              payload = _context3.sent;
              _context3.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context3.next = 3;
              return this.waitForResponse(command, uuid, this.services["pocket"]);
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
              _context3.prev = 4;
              _t3 = _context3["catch"](0);
              console.error("Error in payinCancel:", _t3);
              throw _t3;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 4]]);
      }));
      function payinCancel(_x) {
        return _payinCancel.apply(this, arguments);
      }
      return payinCancel;
    }()
  }, {
    key: "payinRetry",
    value: function () {
      var _payinRetry = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(id) {
        var command, uuid, origin, timestamp, payload, _t4;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              command = "System.MoneyManager.PayinRetry";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context4.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["pocket"], {
                command: command,
                params: {
                  id: id
                }
              }, uuid, origin, timestamp);
            case 1:
              payload = _context4.sent;
              _context4.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context4.next = 3;
              return this.waitForResponse(command, uuid, this.services["pocket"]);
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
              _context4.prev = 4;
              _t4 = _context4["catch"](0);
              console.error("Error in payinRetry:", _t4);
              throw _t4;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 4]]);
      }));
      function payinRetry(_x2) {
        return _payinRetry.apply(this, arguments);
      }
      return payinRetry;
    }()
  }, {
    key: "emptyCashBox",
    value: function () {
      var _emptyCashBox = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var command, uuid, origin, timestamp, payload, _t5;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              command = "System.MoneyManager.EmptyCashBox";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName; // Fixed typo
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context5.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["pocket"], {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              payload = _context5.sent;
              _context5.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context5.next = 3;
              return this.waitForResponse(command, uuid, this.services["pocket"]);
            case 3:
              return _context5.abrupt("return", _context5.sent);
            case 4:
              _context5.prev = 4;
              _t5 = _context5["catch"](0);
              console.error("Error in emptyCashBox:", _t5);
              throw _t5;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 4]]);
      }));
      function emptyCashBox() {
        return _emptyCashBox.apply(this, arguments);
      }
      return emptyCashBox;
    }()
  }, {
    key: "waitForResponse",
    value: function () {
      var _waitForResponse = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(command, uuid, service) {
        var _this3 = this;
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new Promise(function (resolve, reject) {
                _this3.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(msg) {
                    var decryptedData, jsonObject, _t6;
                    return _regenerator["default"].wrap(function (_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          if (!(msg.action === "System.SDK.ServiceCall" && msg.requestUuid === uuid)) {
                            _context6.next = 4;
                            break;
                          }
                          _context6.prev = 1;
                          _context6.next = 2;
                          return _encryption["default"].decryptSymmetrically(service, msg.data);
                        case 2:
                          decryptedData = _context6.sent;
                          jsonObject = JSON.parse(decryptedData);
                          resolve(jsonObject.params);
                          _context6.next = 4;
                          break;
                        case 3:
                          _context6.prev = 3;
                          _t6 = _context6["catch"](1);
                          console.error("Error decrypting data:", _t6);
                          reject(new Error("Failed to decrypt data."));
                        case 4:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee6, null, [[1, 3]]);
                  }));
                  return function (_x6) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function waitForResponse(_x3, _x4, _x5) {
        return _waitForResponse.apply(this, arguments);
      }
      return waitForResponse;
    }()
  }, {
    key: "handleMessages",
    value: function () {
      var _handleMessages = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(message) {
        var origin, _origin$split, _origin$split2, serviceName, target, notification, _t7;
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              origin = message.origin || "";
              _origin$split = origin.split("-"), _origin$split2 = (0, _slicedToArray2["default"])(_origin$split, 2), serviceName = _origin$split2[0], target = _origin$split2[1]; // "dpm" ili "dpm-demoApp"
              if (this.myServices.includes(serviceName)) {
                _context8.next = 1;
                break;
              }
              return _context8.abrupt("return");
            case 1:
              if (!(target && target !== this.appName && target !== this.randomNumber)) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              _t7 = message.action;
              _context8.next = _t7 === "System.SDK.ServiceNotification.Response" ? 3 : _t7 === "System.MoneyManager.MoneyNotifications" ? 4 : 5;
              break;
            case 3:
              this.services[message.origin] = JSON.parse(message.data);
              return _context8.abrupt("continue", 6);
            case 4:
              console.log('ovo je poket log', message.data);
              notification = JSON.parse(message.data);
              this.trigger(notification.type, notification);
              return _context8.abrupt("return");
            case 5:
              return _context8.abrupt("continue", 6);
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function handleMessages(_x7) {
        return _handleMessages.apply(this, arguments);
      }
      return handleMessages;
    }()
  }, {
    key: "maybeFinishInitialization",
    value: function maybeFinishInitialization() {
      if (!this.ready) {
        this.ready = true;
        this.trigger("ready", true);
        _logger["default"].success("Initialization", "Module is now fully ready", "Pocket");
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this4 = this;
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Pocket");
      if (!this.detectServices()) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Pocket");
      } else {
        _logger["default"].success("Initialization done", "Module is now ready", "Pocket");
      }
      this.connection.on("messaging", this.handleMessages.bind(this));
      setTimeout(function () {
        _this4.maybeFinishInitialization();
      }, 3000);
    }
  }]);
}(_core["default"]);